import createReducer from "./createReducer";
import { CONCEPT_DETAIL_ACTIONS } from "./actions/Concepts";

import { HTML_CONCEPT_TYPE, SUPPRESS_SUCCESS_GROWL } from "utils/constants";

export function clearConcept(conceptId){
	return (dispatch, getState) => {
		let currentConcept = getState().conceptDetails;

		if(currentConcept.id === conceptId){
			return;
		}

		return dispatch({
			type:CONCEPT_DETAIL_ACTIONS.CLEAR_CONCEPT_DETAILS,
		});
	};
}

/**
 * Get Concept Details - Action Creator
 * @param {number} libraryId
 * @param {number} conceptId
 */
export function loadConcept(libraryId, conceptId){
	return (dispatch, getState) => {
		if([libraryId, conceptId].some(id => !id)){
			return Promise.reject({
				success: false,
				message: "Can't fetch concept.  Invalid ID.",
			});
		}

		return dispatch({
			type: CONCEPT_DETAIL_ACTIONS.LOAD_CONCEPT_AJAX,
			meta:SUPPRESS_SUCCESS_GROWL,
			AJAX: {
				version: 2,
				url: `ui/creative-libraries/${libraryId}/concepts/${conceptId}`,
				success: CONCEPT_DETAIL_ACTIONS.LOAD_CONCEPT_SUCCESS,
				error: CONCEPT_DETAIL_ACTIONS.LOAD_CREATIVE_ERROR,
			},
		});
	};
}

/**
 * Save Concept - Action Creator
 * @param {number} libraryId
 * @param {object} conceptData Concept data to be saved
 */
export function saveConcept(libraryId, conceptData){
	return (dispatch) => {
		return dispatch({
			type:CONCEPT_DETAIL_ACTIONS.SAVE_CONCEPT_AJAX,
			AJAX:{
				version: 2,
				url:`creative-libraries/${libraryId}/concepts`,
				method:"post",
				data:conceptData,
				success:CONCEPT_DETAIL_ACTIONS.SAVE_CONCEPT_SUCCESS,
				error:CONCEPT_DETAIL_ACTIONS.SAVE_CONCEPT_ERROR,
			},
		});
	};
}

/**
 * Add Existing Creatives to Concept - Action Creator
 * @param {object} params Function parameters
 * @param {number} params.libraryId
 * @param {number} params.conceptId
 * @param {string} params.newConceptName New concept name to overwrite
 */
export function addExistingCreativesToConcept(params){
	const { libraryId, conceptId, newConceptName } = params;

	return (dispatch, getState) => {
		const selectedCreativeIds = getState().selected.existingCreatives
			, conceptData = {
				conceptName: newConceptName,
				conceptType: HTML_CONCEPT_TYPE,
				creativeLibraryId: libraryId,
				creativeIds: selectedCreativeIds,
			};

		return dispatch({
			type: CONCEPT_DETAIL_ACTIONS.ADD_EXISTING_CREATIVES_TO_CONCEPT,
			AJAX: {
				version: 2,
				url: `creative-libraries/${libraryId}/concepts/${conceptId}`,
				method: 'put',
				data: conceptData,
				success: CONCEPT_DETAIL_ACTIONS.ADD_EXISTING_CREATIVES_TO_CONCEPT_SUCCESS,
				error: CONCEPT_DETAIL_ACTIONS.ADD_EXISTING_CREATIVES_TO_CONCEPT_ERROR,
			},
		});
	};
}

export function removeCreativesFromConcept(libraryId, creativeIds, opts = {}){
	return (dispatch) => {
		return dispatch({
			type: CONCEPT_DETAIL_ACTIONS.REMOVE_CREATIVES_FROM_CONCEPT_AJAX,
			AJAX: {
				url: `creative-libraries/${libraryId}/concepts/unlink`,
				method: 'post',
				data: creativeIds,
				success: CONCEPT_DETAIL_ACTIONS.REMOVE_CREATIVES_FROM_CONCEPT_SUCCESS,
				error: CONCEPT_DETAIL_ACTIONS.REMOVE_CREATIVES_FROM_CONCEPT_ERROR,
			},
			...opts,
		});
	};
}

/**
 * Add new AdStudio Creatives to Concept - Action Creator
 * @param {number} libraryId
 * @param {number} conceptId
 * @param {object} conceptData AdStudio Concept data to be saved
 */
export function addNewAdstudioCreativesToConcept(libraryId, conceptId, conceptData){
	return (dispatch, getState) => {
		return dispatch({
			type: CONCEPT_DETAIL_ACTIONS.ADD_EXISTING_CREATIVES_TO_CONCEPT,
			AJAX: {
				version: 2,
				url: `creative-libraries/${libraryId}/concepts/${conceptId}`,
				method: 'put',
				data: conceptData,
				success: CONCEPT_DETAIL_ACTIONS.ADD_EXISTING_CREATIVES_TO_CONCEPT_SUCCESS,
				error: CONCEPT_DETAIL_ACTIONS.ADD_EXISTING_CREATIVES_TO_CONCEPT_ERROR,
			},
		});
	};
}

/**
 * Add new Creative Tags to Concept - Action Creator
 * @param {number} libraryId
 * @param {number} conceptId
 * @param {object} conceptData Creative Tag Concept data to be saved
 */
export function addNewCreativeTagsToConcept(libraryId, conceptId, conceptData){
	return (dispatch, getState) => {
		return dispatch({
			type: CONCEPT_DETAIL_ACTIONS.ADD_NEW_DISPLAY_HTML_TAGS_TO_CONCEPT_AJAX,
			AJAX: {
				version: 2,
				url: `creative-libraries/${libraryId}/concepts/${conceptId}`,
				method: 'put',
				data: conceptData,
				success: CONCEPT_DETAIL_ACTIONS.ADD_NEW_DISPLAY_HTML_TAGS_TO_CONCEPT_SUCCESS,
				error: CONCEPT_DETAIL_ACTIONS.ADD_NEW_DISPLAY_HTML_TAGS_TO_CONCEPT_ERROR,
			},
		});
	};
}

function isLoadingConcept(state, action){
	return {
		...state,
		isLoaded:false,
		hasErrorLoading:false,
		isSaving:false,
		data:{ ...initConceptDetails.data },
	};
}

function errorConcept(state, action){
	return {
		...state,
		isLoaded:true,
		hasErrorLoading:true,
		error:{},
		isSaving:false,
		data:{},
	};
}
function initConcept(state, action){
	return {
		...state,
		isLoaded:true,
		isSaving:false,
		hasErrorLoading:false,
		data:{ ...action.payload.data },
	};
}

/**
 * Save Social Concept - Action Creator
 * @param {number} libraryId
 * @param {object} concept Social concept data
 */
export function saveNewSocial2Concept(libraryId, concept, supportIncomplete = true){
	return (dispatch) => {
		return dispatch({
			type: CONCEPT_DETAIL_ACTIONS.SAVE_NEW_SOCIAL_CONCEPT2_AJAX,
			AJAX:{
				version: 2,
				url: `ui/creative-libraries/${libraryId}/concepts?supportIncomplete=${supportIncomplete}`,
				method: "post",
				data: concept,
				success: CONCEPT_DETAIL_ACTIONS.SAVE_NEW_SOCIAL_CONCEPT2_SUCCESS,
				error: CONCEPT_DETAIL_ACTIONS.SAVE_NEW_SOCIAL_CONCEPT2_ERROR,
			},
		});
	};
}

/**
 * Add Creatives to Social Concept - Action Creator
 * @param {number} libraryId
 * @param {number} conceptId
 * @param {object} concept
 * @param {Array} newAdTypes
 */
export function addCreativesToSocial2Concept(libraryId, conceptId, concept, newAdTypes = [], supportIncomplete = true){
	return (dispatch) => {
		return dispatch({
			type: CONCEPT_DETAIL_ACTIONS.ADD_CREATIVE_TO_SOCIAL_CONCEPT2_AJAX,
			AJAX:{
				version: 2,
				url: `ui/creative-libraries/${libraryId}/concepts/${conceptId}?supportIncomplete=${supportIncomplete}`,
				method: "put",
				data: concept,
				success: CONCEPT_DETAIL_ACTIONS.ADD_CREATIVE_TO_SOCIAL_CONCEPT2_SUCCESS,
				error: CONCEPT_DETAIL_ACTIONS.ADD_CREATIVE_TO_SOCIAL_CONCEPT2_ERROR,
			},
			newAdTypes,
		});
	};
}

export function updateDisplayHtmlTag(libraryId, creativeId, data) {
	return(dispatch) => {
		return dispatch({
			type: CONCEPT_DETAIL_ACTIONS.UPDATE_DISPLAY_HTML_TAG_AJAX,
			AJAX: {
				url: `ui/creative-libraries/${libraryId}/concepts/update-display-html-tag/${creativeId}`,
				method: "post",
				data,
				success: CONCEPT_DETAIL_ACTIONS.UPDATE_DISPLAY_HTML_TAG_SUCCESS,
				error: CONCEPT_DETAIL_ACTIONS.UPDATE_DISPLAY_HTML_TAG_ERROR,
			},
		});
	};
}

function initSaving(state, action){
	return {
		...state,
		isSaving:true,
	};
}
function saveConceptSuccess(state, action){
	return {
		...state,
		data:action.payload.data,
		isSaving:false,
	};
}

function saveConceptFail(state, action){
	const { errorObj } = action.payload;
	return {
		...state,
		isSaving:false,
		hasErrorsSaving:true,
		errors: { ...errorObj },
	};
}

const initConceptDetails = {
	isLoaded: false,
	isSaving: false,
	hasErrorLoading: false,
	data:{
		adTypes:[],
		conceptName:"",
		conceptID:-1,
	},
};

const handlers = {
	[CONCEPT_DETAIL_ACTIONS.CLEAR_CONCEPT_DETAILS]: clearForm,

	[CONCEPT_DETAIL_ACTIONS.LOAD_CONCEPT_AJAX]:    isLoadingConcept,
	[CONCEPT_DETAIL_ACTIONS.LOAD_CONCEPT_SUCCESS]: initConcept,
	[CONCEPT_DETAIL_ACTIONS.LOAD_CREATIVE_ERROR]:  errorConcept,

	[CONCEPT_DETAIL_ACTIONS.SAVE_SOCIAL_CONCEPT_AJAX]:        initSaving,
	[CONCEPT_DETAIL_ACTIONS.SAVE_SOCIAL_CONCEPT_SUCCESS]:     saveConceptSuccess,
	[CONCEPT_DETAIL_ACTIONS.SAVE_SOCIAL_CONCEPT_ERROR]:       saveConceptFail,
	[CONCEPT_DETAIL_ACTIONS.SAVE_NEW_SOCIAL_CONCEPT_AJAX]:    initSaving,
	[CONCEPT_DETAIL_ACTIONS.SAVE_NEW_SOCIAL_CONCEPT_SUCCESS]: saveConceptSuccess,
	[CONCEPT_DETAIL_ACTIONS.SAVE_ADD_TO_SOCIAL_CONCEPT_SUCCESS]:saveConceptSuccess,
	[CONCEPT_DETAIL_ACTIONS.SAVE_NEW_SOCIAL_CONCEPT_ERROR]:   saveConceptFail,

	[CONCEPT_DETAIL_ACTIONS.SAVE_NEW_SOCIAL_CONCEPT2_AJAX]:    initSaving,
	[CONCEPT_DETAIL_ACTIONS.SAVE_NEW_SOCIAL_CONCEPT2_SUCCESS]: saveConceptSuccess,
	[CONCEPT_DETAIL_ACTIONS.SAVE_NEW_SOCIAL_CONCEPT2_ERROR]:   saveConceptFail,

	[CONCEPT_DETAIL_ACTIONS.ADD_CREATIVE_TO_SOCIAL_CONCEPT2_AJAX]: initSaving,
	[CONCEPT_DETAIL_ACTIONS.ADD_CREATIVE_TO_SOCIAL_CONCEPT2_SUCCESS]: saveConceptSuccess,
	[CONCEPT_DETAIL_ACTIONS.ADD_CREATIVE_TO_SOCIAL_CONCEPT2_ERROR]: saveConceptFail,

	[CONCEPT_DETAIL_ACTIONS.UPDATE_DISPLAY_HTML_TAG_AJAX]: initSaving,
	[CONCEPT_DETAIL_ACTIONS.UPDATE_DISPLAY_HTML_TAG_SUCCESS]: saveConceptSuccess,
	[CONCEPT_DETAIL_ACTIONS.UPDATE_DISPLAY_HTML_TAG_ERROR]: saveConceptFail,

	[CONCEPT_DETAIL_ACTIONS.ADD_NEW_DISPLAY_HTML_TAGS_TO_CONCEPT_AJAX]: initSaving,
	[CONCEPT_DETAIL_ACTIONS.ADD_NEW_DISPLAY_HTML_TAGS_TO_CONCEPT_SUCCESS]: saveConceptSuccess,
	[CONCEPT_DETAIL_ACTIONS.ADD_NEW_DISPLAY_HTML_TAGS_TO_CONCEPT_ERROR]: saveConceptFail,
};

function clearForm(state, action){
	return { ...initConceptDetails };
}

export const PRIVATE = {
	clearForm,
};

export default createReducer(initConceptDetails, handlers);
